<template>
  <div class="difficulty-stars" :class="{ compact }" @click.stop>
    <el-rate
      :value="normalized"
      :max="5"
      :disabled="readonly"
      :colors="['#F7BA2A', '#F7BA2A', '#F7BA2A']"
      void-color="#dcdfe6"
      @change="handleChange"
    />
  </div>
</template>

<script>
export function normalizeDifficulty(val) {
  const n = Number(val)
  if (!n || n < 2) return 2
  if (n > 5) return 5
  return n
}

export default {
  name: 'DifficultyStars',
  props: {
    value: { type: [Number, String], default: 2 },
    readonly: { type: Boolean, default: true },
    compact: { type: Boolean, default: false }
  },
  computed: {
    normalized() {
      return normalizeDifficulty(this.value)
    }
  },
  methods: {
    handleChange(val) {
      const difficulty = normalizeDifficulty(val)
      this.$emit('input', difficulty)
      this.$emit('change', difficulty)
    }
  }
}
</script>

<style scoped>
.difficulty-stars {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}
.difficulty-stars >>> .el-rate__icon {
  font-size: 16px;
  margin-right: 2px;
}
.difficulty-stars.compact >>> .el-rate__icon {
  font-size: 14px;
}
</style>
